<template>
  <BaseField :element="element" :model="internalModel">
    <template v-slot:default="{ errors }">
      <v-text-field
        v-model="internalModel"
        :name="field.id"
        :label="fieldLabel"
        :hint="field.hint"
        :persistent-hint="field.persistentHint"
        :placeholder="field.placeholder"
        :disabled="field.disabled"
        :readonly="field.readonly"
        :required="field.required"
        :error="errors.length > 0"
        :error-messages="errors"
        :outlined="!field.readonly"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        @focus="$event.target.select()"
        @click:append="showPassword = !showPassword"
      ></v-text-field>
    </template>
  </BaseField>
</template>

<script>
import BaseField from "@/components/form/fields/BaseField";
import Component from "vue-class-component";

@Component()
export default class PasswordField extends BaseField {
  showPassword = false;
}
</script>